import styled from 'styled-components';
import { th } from 'style/theme';

export const CreditInfo = styled.div`
  display: flex;
  padding: 8px 12px;
  border-radius: 16px;
  margin-top: 32px;
  background-color: ${th('colors.sushi+4')};
  color: ${th('colors.pickledBluewood')};

  > svg {
    flex-shrink: 0;
    width: 20px;
    margin-right: 8px;
  }
`;

export const DiscountedPrice = styled.span`
  font-weight: 500;
`;
